// extracted by mini-css-extract-plugin
module.exports = {"paymentStatusWrapper":"PaymentStatus_paymentStatusWrapper__R6_yW","statusActions":"PaymentStatus_statusActions__CONYS","writeOff":"PaymentStatus_writeOff__Ajxqs"};